import { forwardRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TextInput } from "../textInput";
import { calendar, close } from "helper/icons";
import moment from "moment";
import "./modules.css";
import { globalVariables } from "helper/globalVariables";
import { DEFAULT_DATE_FORMAT } from "helper/utility";

const CustomDatePicker = (props) => {
  const {
    width = "w-[358px] lg:w-[384px] max-[400px]:w-[100%]",
    placeholder,
    dateFormat = DEFAULT_DATE_FORMAT,
    showIconLeft = false,
    defaultDate = false,
    onSetDate,
    checkValidation, 
    label,
    disabled = false,
    isFaded,
    maxDate,
    minDate,
    onClear,
  } = props || {};
  const [selectedDate, setSelectedDate] = useState(defaultDate);

  useEffect(() => {
    setSelectedDate(defaultDate);
  }, [defaultDate]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onSetDate(date);
  };

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div
      ref={ref}
      className={`w-full flex ${
        showIconLeft ? "flex-row-reverse" : "flex-row"
      }`}
    >
      {onClear && selectedDate && !disabled && (
        <div
          onClick={() => {
            if (selectedDate) {
              onClear();
            }
          }}
        >
          <img
            src={close}
            alt=""
            height={20}
            width={20}
            className={`${
              showIconLeft
                ? "custom-icon cursor-pointer"
                : "custom-icon-right cursor-pointer"
            }`}
          />
        </div>
      )}
      <div
        onClick={() => {
          if (!disabled) {
            onClick();
          }
        }}
        className="w-full"
      >
        <TextInput
          value={selectedDate ? moment(selectedDate).format(dateFormat) : ""}
          placeholder={placeholder}
          width={"w-full"}
          className={`${isFaded ? "bg-[#ffffff80]" : ""} ${
            showIconLeft ? "pl-9" : ""
          }`}
          errorMsg={
            !defaultDate && checkValidation && globalVariables.pleaseSelectDate
          }
          disabled={disabled}
        />
        {!disabled && (
          <img
            src={calendar}
            alt=""
            height={20}
            width={20}
            className={
              showIconLeft
                ? "custom-icon-left"
                : !defaultDate && checkValidation
                ? "custom-icon-error"
                : "custom-icon"
            }
          />
        )}
      </div>
    </div>
  ));

  return (
    <div className={width}>
      {!!label && (
        <span className="text-gray-700 font-medium text-sm">{label}</span>
      )}
      <div
        className={`relative flex ${
          showIconLeft ? "flex-row-reverse" : "flex-row"
        } `}
      >
        <DatePicker
          selected={selectedDate ?? new Date()}
          onChange={handleDateChange}
          customInput={<CustomInput />}
          maxDate={maxDate}
          minDate={minDate}
        />
      </div>
    </div>
  );
};

export default CustomDatePicker;
